import React from 'react'

export const Handler = () => (
  <svg width="85" height="60">
    <g fill="none">
      <path fill="#000" d="M10 23v16L0 31zm65 0v16l10-8z" />
      <g transform="translate(13)">
        <ellipse
          cx="29.5"
          cy="30"
          fill="#000"
          stroke="#FFF"
          rx="29.294"
          ry="29.5"
        />
        <path
          fill="#FFF"
          d="M4.178 30c0-14.08 11.34-25.5 25.322-25.5S54.822 15.92 54.822 30 43.482 55.5 29.5 55.5 4.178 44.08 4.178 30z"
        />
        <path
          fill="#000"
          d="M35.746 23.17c0 3 .338 4.5-2.165 7.66v3.84c1.669 1 4.33 2 6.157 2.33 2.83.67 3.664 1.17 3.664 3.33 0 1-.496 3.17-2.164 3.17H17.614c-2.334-1.17-1.996-2-1.996-3.17 0-2.83 1.49-2.83 4.826-3.66 1.658-.34 3.326-1.17 4.985-2V30.5c-1.162-1.33-1.996-4-1.996-5.5v-4.83c1.5-3.67 3.495-3.67 5.988-3.67 5.332 0 6.325 2.17 6.325 6.67z"
        />
      </g>
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/components/PollForm/handler.js